import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-need',
  templateUrl: './business-need.component.html',
  styleUrls: ['./business-need.component.css']
})
export class BusinessNeedComponent implements OnInit {
  //VER
  titleSectionProp: any = {
    title: 'Recibí candidatos listos para entrevistar.',
    description: 'Solo envianos tu búsqueda y nuestro sistema se encargará del resto.',
    class: 'text-left'
  };

  List: any[] = [
    {
      title: 'Potabilidad asegurada',
      icon: 'ion ion-checkmark-round',
    },
    {
      title: 'Entregas con alta frecuencia',
      icon: 'ion ion-checkmark-round',
    },
    {
      title: 'Paga solo por lo que usas',
      icon: 'ion ion-checkmark-round'
    },
    {
      title: 'Exposición 0',
      icon: 'ion ion-checkmark-round'
    },
    {
      title: 'Métodos no invasivos',
      icon: 'ion ion-checkmark-round',
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
